/* -----------------------------
    SLIDER FILTER COMPONENT
   ----------------------------- */
class SliderFilters extends HTMLElement {
  constructor() {
    super();

    this.filters = [...this.querySelectorAll(this.selectors.filter)];
  }

  get selectors() {
    return {
      filter: "slider-filter"
    }
  }

  get modifiers() {
    return {
      active: "active"
    }
  }

  get datasets() {
    return {
      controls: "controls",
      value: "value"
    }
  }

  connectedCallback() {
    this.initFilters();
  }

  initFilters() {
    const controlledSliderId = this.getAttribute(this.datasets.controls);

    if (!controlledSliderId) {
      return;
    }

    this.controlledSlider = document.getElementById(controlledSliderId);

    if (!this.controlledSlider) {
      return;
    }

    this.customDelegate(
      "click",
      this.selectors.filter,
      this.filterSlider.bind(this)
    );
  }

  filterSlider(event) {
    const currentFilter = event.target;
    const currentFilterValue = currentFilter.getAttribute(this.datasets.value) ?? this.resetFilterValue;

    this.controlledSlider.dispatchEvent(new CustomEvent("slider:filter", {
      detail: {
        filterValue: currentFilterValue
      }
    }));

    this.filters.forEach((button) => {
      button.classList.remove(this.modifiers.active);
    });

    currentFilter.classList.add(this.modifiers.active);
  }
}

if (!customElements.get("slider-filters")) {
  customElements.define("slider-filters", SliderFilters);
}
